import React from 'react';
import {FilterProps} from 'react-table';

import {ApiShareLink} from 'app/modules/Remote/ShareLink';

import {shareLinkTypes} from './shareLinksTableState';
import {SelectColumnFilter} from '../PortfolioReports/PortfolioReportsColumnFilters';

export const TypeColumnFilter: React.FunctionComponent<FilterProps<ApiShareLink>> = ({
  column,
  setFilter,
  data,
}) => {
  const types = React.useMemo(() => shareLinkTypes(data), [data]);

  return (
    <SelectColumnFilter
      allText="All types"
      options={types.map((type) => ({id: type, name: type}))}
      value={column.filterValue}
      setValue={(value) => setFilter(column.id, value)}
    />
  );
};
